<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Alterar vendedor responsável</h2>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()" [disabled]="isLoading">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <p class="subtitulo">
        {{ data.idsVendedores.length }} vendedor(es) selecionado(s): {{ data.nomesVendedores.join(', ') }}
    </p>

    <app-select-pesquisavel [control]="novoResponsavelControl" [offlineList]="opcoesNovoResponsavel"
        label="Novo Vendedor Responsável" idField="idVendedor" nameField="nome" [subtitleFields]="['motivo']"
        [isOptional]="true" emptyOptionLabel="Nenhum"
        hint="Deixe em branco para remover o vendedor responsável dos selecionados.">
    </app-select-pesquisavel>

    @if (impactoPreview.length > 0) {
    <div class="impacto-preview">
        <div class="impacto-preview-titulo">O que acontece ao confirmar</div>
        @for (linha of impactoPreview; track $index) {
        <div class="impacto-preview-linha" [class.sem-alteracao]="linha.semAlteracao">
            <mat-icon>{{ linha.icone }}</mat-icon>
            <span>{{ linha.texto }}</span>
        </div>
        }
    </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button class="btn-secondary" (click)="cancelar()" [disabled]="isLoading">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="isLoading">
        @if (isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        Confirmar
        }
    </button>
</mat-dialog-actions>
